// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".close-button[data-v-0b327a87]{right:1.5rem;top:1rem}.close-button[data-v-0b327a87],.dialog-title[data-v-0b327a87]{background:rgba(0,0,0,.5);position:fixed;z-index:2}.dialog-title[data-v-0b327a87]{left:1.5rem;top:2rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
